import React, {Component} from 'react';
import DirectoryContainer from '../common/directory/DirectoryContainer';
import {CATEGORY_ITEMS} from "../editors/TreeEditorRouteTypes";

export default class CategoryTypes extends Component {

    render() {
        return (
            <DirectoryContainer
                items={CATEGORY_ITEMS}
            />
        );
    }

}


// WEBPACK FOOTER //
// ./web/src/components/categories/CategoryTypes.jsx